
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cl/[collectionName]",
      function () {
        return require("private-next-pages/cl/[collectionName].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cl/[collectionName]"])
      });
    }
  